/**
 * Controls whether or not users will see updated messaging on auto-enrolled free trial of Insider
 */
export const SHOW_UPDATED_MESSAGING_ON_AUTO_ENROLLED_FREE_TRIAL_240509 = 'SHOW_UPDATED_MESSAGING_ON_AUTO_ENROLLED_FREE_TRIAL_240509';
